// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button_3qCqk1oxfcBP22JJRXVPOn","clear":"styles_clear_VPvL6w38atObGi83XJvAB"};